export default {
    GERENTE: 'manager',
    RRHH: 'rrhh',
    GENERAL: 'general',
  };
  